/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FilterBinderClaimsQueryDto
 */
export interface FilterBinderClaimsQueryDto {
    /**
     * Filter by insured
     * @type {Array<string>}
     * @memberof FilterBinderClaimsQueryDto
     */
    insureds?: Array<string>;
    /**
     * Filter by claimStatus
     * @type {Array<string>}
     * @memberof FilterBinderClaimsQueryDto
     */
    statuses?: Array<FilterBinderClaimsQueryDtoStatusesEnum>;
    /**
     * Filter by claims handler
     * @type {Array<string>}
     * @memberof FilterBinderClaimsQueryDto
     */
    claimsHandler?: Array<string>;
    /**
     * Filter by reported date from
     * @type {Date}
     * @memberof FilterBinderClaimsQueryDto
     */
    dateReportedFrom?: Date;
    /**
     * Filter by reported date to
     * @type {Date}
     * @memberof FilterBinderClaimsQueryDto
     */
    dateReportedTo?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof FilterBinderClaimsQueryDto
     */
    includeClaim?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilterBinderClaimsQueryDto
     */
    includeSubmission?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilterBinderClaimsQueryDto
     */
    includeContract?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilterBinderClaimsQueryDto
     */
    includeBinderClaimDetails?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilterBinderClaimsQueryDto
     */
    includeClaimHandler?: boolean;
    /**
     * Filter by claim
     * @type {Array<string>}
     * @memberof FilterBinderClaimsQueryDto
     */
    claims?: Array<string>;
}


/**
 * @export
 */
export const FilterBinderClaimsQueryDtoStatusesEnum = {
    PreCautionary: 'Pre-cautionary',
    Registered: 'Registered',
    InProgress: 'In-progress',
    Closed: 'Closed'
} as const;
export type FilterBinderClaimsQueryDtoStatusesEnum = typeof FilterBinderClaimsQueryDtoStatusesEnum[keyof typeof FilterBinderClaimsQueryDtoStatusesEnum];


/**
 * Check if a given object implements the FilterBinderClaimsQueryDto interface.
 */
export function instanceOfFilterBinderClaimsQueryDto(value: object): value is FilterBinderClaimsQueryDto {
    return true;
}

export function FilterBinderClaimsQueryDtoFromJSON(json: any): FilterBinderClaimsQueryDto {
    return FilterBinderClaimsQueryDtoFromJSONTyped(json, false);
}

export function FilterBinderClaimsQueryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilterBinderClaimsQueryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'insureds': json['insureds'] == null ? undefined : json['insureds'],
        'statuses': json['statuses'] == null ? undefined : json['statuses'],
        'claimsHandler': json['claimsHandler'] == null ? undefined : json['claimsHandler'],
        'dateReportedFrom': json['dateReportedFrom'] == null ? undefined : (new Date(json['dateReportedFrom'])),
        'dateReportedTo': json['dateReportedTo'] == null ? undefined : (new Date(json['dateReportedTo'])),
        'includeClaim': json['includeClaim'] == null ? undefined : json['includeClaim'],
        'includeSubmission': json['includeSubmission'] == null ? undefined : json['includeSubmission'],
        'includeContract': json['includeContract'] == null ? undefined : json['includeContract'],
        'includeBinderClaimDetails': json['includeBinderClaimDetails'] == null ? undefined : json['includeBinderClaimDetails'],
        'includeClaimHandler': json['includeClaimHandler'] == null ? undefined : json['includeClaimHandler'],
        'claims': json['claims'] == null ? undefined : json['claims'],
    };
}

export function FilterBinderClaimsQueryDtoToJSON(json: any): FilterBinderClaimsQueryDto {
    return FilterBinderClaimsQueryDtoToJSONTyped(json, false);
}

export function FilterBinderClaimsQueryDtoToJSONTyped(value?: FilterBinderClaimsQueryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'insureds': value['insureds'],
        'statuses': value['statuses'],
        'claimsHandler': value['claimsHandler'],
        'dateReportedFrom': value['dateReportedFrom'] == null ? undefined : ((value['dateReportedFrom']).toISOString()),
        'dateReportedTo': value['dateReportedTo'] == null ? undefined : ((value['dateReportedTo']).toISOString()),
        'includeClaim': value['includeClaim'],
        'includeSubmission': value['includeSubmission'],
        'includeContract': value['includeContract'],
        'includeBinderClaimDetails': value['includeBinderClaimDetails'],
        'includeClaimHandler': value['includeClaimHandler'],
        'claims': value['claims'],
    };
}

